import { plotLayout } from '../../core/components/chart-grid/ChartGrid.sty.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { Group } from '../../core/components/series-action/components/Group.js';
import { GridLayout } from '../components/grid/GridLayout.js';
import { useCategoricalBarChartBaseConfig } from '../hooks/useCategoricalBarChartBaseConfig.js';
import { useCategoricalBarChartScales } from '../hooks/useCategoricalBarChartScales.js';

export const CategoricalGridLayout = () => {
  const { width, height } = useGridPlotSize();
  const { layout } = useCategoricalBarChartBaseConfig();
  const { valueScale } = useCategoricalBarChartScales();

  return (
    <svg className={plotLayout}>
      <Group data-testid="chart-grid">
        <GridLayout
          layout={layout}
          width={width}
          height={height}
          scale={valueScale}
        />
      </Group>
    </svg>
  );
};

CategoricalGridLayout['displayName'] = 'CategoricalGridLayout';
